import i18n from '@/i18n'
import { USER_TYPE } from '@/constants'
import { getTranslatedProperty } from './getTranslatedProperty'

export const getProductLocation = (product, shortCityName = false, breakLineOnCommas = false) => {
  const locationParams = {
    countryName: '',
    cityName: '',
    address: '',
    countryCode: '',
  }

  // Для продуктов экспортера выводятся страна/город из incoterms
  if (product.seller.user.user_type === USER_TYPE.EXPORTER) {
    const { incoterms_country, incoterms_city } = product.seller.term_condition

    locationParams.countryName = incoterms_country ? getTranslatedProperty(incoterms_country) : i18n.t('Unknown')
    locationParams.cityName = incoterms_city ? getTranslatedProperty(incoterms_city) : i18n.t('Unknown')
    locationParams.countryCode = incoterms_country?.short_code || ''

    return locationParams
  }
  // Для других адресом является адрес основного склада продавца
  const warehouseAddress = product.warehouse_address

  locationParams.countryName = warehouseAddress?.city?.country_name || i18n.t('Unknown')
  locationParams.cityName = warehouseAddress?.city ? getTranslatedProperty(warehouseAddress.city) : i18n.t('Unknown')
  locationParams.address = warehouseAddress?.address || i18n.t('Unknown')
  locationParams.countryCode = warehouseAddress?.city?.country_short_code || ''

  let cityStr = shortCityName ? locationParams.cityName.split(',')[0] : locationParams.cityName

  if (breakLineOnCommas) {
    cityStr = cityStr.replace(/,/g, ',\n')
  }

  return {
    ...locationParams,
    cityName: cityStr,
  }
}
